import BlueBuffalo from './blue_buffalo.svg';
import Canon from './canon.svg';
import CocaCola from './coca_cola.svg';
import CoronaExtra from './corona_extra.svg';
import Dove from './dove_logo.svg';
import FoxSports from './fox_sports.svg';
import KraftHeinz from './kraft_heinz.svg';
import NaturesWay from './natures_way.svg';
import OceanSpray from './ocean_spray.svg';
import Oreo from './oreo.svg';
import RoyalCanin from './royal_canin.svg';
import SKYY from './skyy.svg';

export default [
  CoronaExtra,
  CocaCola,
  Oreo,
  RoyalCanin,
  Dove,
  FoxSports,
  SKYY,
  OceanSpray,
  KraftHeinz,
  BlueBuffalo,
  NaturesWay,
  Canon,
];
